{
  "nav": {
    "tools": "Herramientas",
    "openMenu": "Abrir menú",
    "subscription": "Suscripción",
    "configuration": "Configuración",
    "account": "Cuenta",
    "administration": "Administración",
    "ourTools": "Nuestras herramientas",
    "pricing": "Precios",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Herramienta de flipping",
    "dropshipTool": "Herramienta de dropship",
    "housingTool": "Herramienta de housing",
    "inventoryAnalysisTool": "Herramienta de análisis de inventario",
    "snipeAlerts": "Alertas de snipe",
    "realmStats": "Estadísticas de reino",
    "tsmListGenerator": "Generador de listas TSM",
    "tsmProfileSetupGuide": "Guía de configuración de perfil TSM",
    "dashboard": "Panel",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Configuración de región y reino",
    "personal": "Configuración personal",
    "discord": "Configuración de Discord"
  },
  "accountItems": {
    "settings": "Ajustes"
  },
  "adminItems": {
    "stats": "Estadísticas",
    "userInfo": "Información de usuario",
    "goldSubscription": "Suscripción de oro",
    "itemLookup": "Búsqueda de artículo",
    "snipeAudit": "Auditoría de snipe",
    "emailPreviews": "Vista previa de correos"
  },
  "buttons": {
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "register": "Registrarse",
    "registerNow": "Registrarse ahora",
    "signIn": "Entrar",
    "tryAgain": "Intentar de nuevo",
    "goBack": "Regresar",
    "cancel": "Cancelar",
    "deactivate": "Desactivar",
    "upgrade": "Mejorar",
    "upgradeToPremium": "Mejorar a Premium",
    "upgradeNow": "Mejorar ahora",
    "unlockPremiumFeatures": "Desbloquear funciones Premium",
    "getMoreResultsAndFilters": "Obtener más resultados y filtros",
    "goToConfig": "Ir a configuración",
    "save": "Save",
    "close": "Cerrar",
    "actions": "Acciones",
    "copyToClipboard": "Copiar al portapapeles",
    "saving": "Guardando…"
  },
  "loading": {
    "pleaseWait": "Por favor espera",
    "important": "Importante",
    "defaultWarning": "Por favor, no recargues la página durante este proceso.",
    "progressComplete": "{{percent}}% completado",
    "loadingAriaLabel": "Cargando",
    "loadingProgressAriaLabel": "Progreso de carga: {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Algo salió mal",
    "defaultMessage": "¡Ocurrió un error! Espera unos segundos y recarga la página",
    "fetchDataFailed": "No se pudieron cargar los datos de subastas"
  },
  "cancelDialog": {
    "title": "Cancelar suscripción",
    "confirmQuestion": "¿Estás seguro de que quieres cancelar tu suscripción?",
    "loseAccessNotice": "Perderás el acceso a las herramientas y no se te cobrarán pagos futuros.",
    "warning": "Advertencia: una vez que canceles tu suscripción, perderás el acceso a las herramientas al finalizar tu acceso de pago y no realizaremos reembolsos por suscripciones canceladas."
  },
  "dialog": {
    "confirm": "Confirmar",
    "cancel": "Cancelar"
  },
  "realmLimitPopup": {
    "title": "Límite de reinos superado",
    "description": "Tienes más reinos de venta seleccionados de los que permite la suscripción básica. Cambia tu configuración o mejora a premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Mejorar a Premium",
    "upgradeSubtitle": "Desbloquea todo el poder de Flipping Pal",
    "enhancedFeatures": "Funciones mejoradas",
    "exclusiveFeatures": "Funciones Premium exclusivas",
    "alsoIncluded": "También incluido"
  },
  "footer": {
    "changelog": "Registro de cambios"
  },
  "logoAlt": "Flipping Pal - tu sitio de flipping WoW favorito",
  "toggleNavAriaLabel": "Alternar menú de navegación",
  "mainNavAriaLabel": "Navegación principal",
  "toolNavAriaLabel": "Navegación de herramientas",
  "simpleNavAriaLabel": "Navegación simple",
  "footerNavAriaLabel": "Navegación del pie de página",
  "clipboard": {
    "copied": "¡Copiado al portapapeles!",
    "tsmCopied": "¡Cadena TSM copiada al portapapeles!",
    "exportCopied": "Código de exportación copiado exitosamente al portapapeles.",
    "auctionatorCopied": "¡Listas de compras de Auctionator copiadas al portapapeles!",
    "titleCopied": "¡{{title}} copiado al portapapeles!",
    "copyFailed": "Error al copiar al portapapeles"
  },
  "favorites": {
    "added": "Agregado a favoritos",
    "removed": "Eliminado de favoritos"
  },
  "enabled": "activado",
  "disabled": "desactivado",
  "dataRefreshed": "¡Datos actualizados! Se encontraron {{count}} oportunidades.",
  "notFound": {
    "title": "Página no encontrada"
  },
  "paymentSuccess": {
    "title": "Pago exitoso"
  },
  "pagination": {
    "summary": "Total de artículos encontrados: {{total}} | Resultados por página: {{perPage}}",
    "summaryWithPages": "Total de artículos encontrados: {{total}} | Resultados por página: {{perPage}} | Total de páginas: {{pages}}",
    "label": "Paginación",
    "firstPage": "Primera página",
    "previousPage": "Página anterior",
    "nextPage": "Página siguiente",
    "lastPage": "Última página",
    "pageAriaLabel": "Página {{page}}"
  },
  "stats": {
    "totalInvestment": "Inversión total",
    "estimatedSellPrice": "Precio de venta estimado",
    "profitAfterAHCut": "Ganancia tras la comisión de la casa de subastas"
  },
  "filters": {
    "searchItems": "Buscar artículos...",
    "watchVideoGuide": "Ver guía en video",
    "watchVideoIntro": "Ver el video de introducción",
    "crossRealmVideoGuide": "Guía en video de la herramienta de flipping entre reinos",
    "dropshipVideoGuide": "Guía en video de la herramienta de flipping dropship",
    "housingVideoGuide": "Guía en video de la herramienta de housing",
    "downloadXLSX": "Descargar datos como XLSX",
    "getAuctionatorLists": "Obtener listas de Auctionator",
    "quality": "Calidad",
    "selectQuality": "Seleccionar calidad",
    "qualities": "calidades",
    "expansions": "Expansiones",
    "selectExpansions": "Seleccionar expansiones",
    "expansionsMultiple": "expansiones",
    "sellingRealms": "Reinos de venta",
    "selectSellingRealms": "Seleccionar reinos de venta",
    "sellingRealmsMultiple": "reinos de venta",
    "buyingRealms": "Reinos de compra",
    "selectBuyingRealms": "Seleccionar reinos de compra",
    "buyingRealmsMultiple": "reinos de compra",
    "categories": "Categorías",
    "selectCategories": "Seleccionar categorías",
    "categoriesMultiple": "categorías",
    "sellRate": "Tasa de venta",
    "saleAvg": "Media de ventas",
    "haveCraftedItems": "Objetos fabricados",
    "profitOnSaleAvg": "Beneficio sobre la media de ventas",
    "saleAvgVsBuyPercent": "Media de ventas vs compra %",
    "profitSellVsBuy": "Beneficio (venta vs compra)",
    "profitPercent": "Beneficio %",
    "maxGoldBuyout": "Compra directa máx. en oro",
    "ilvl": "ilvl",
    "activateProfitOnSaleAvg": "Activar beneficio sobre la media de ventas",
    "regionMarketValue": "Valor de mercado regional",
    "regionHistorical": "Valor histórico regional",
    "modeRecalculate": "Recalcular",
    "modeFilter": "Filtrar",
    "modeRecalculateHint": "Los cambios de filtro recalculan los resultados en el servidor",
    "modeFilterHint": "Los cambios de filtro solo acotan los resultados ya cargados",
    "modeAria": "Comportamiento al cambiar filtros",
    "modeLabel": "Al cambiar filtros"
  },
  "table": {
    "noData": "No se encontraron datos",
    "sellVsBuyTooltip": "La comisión del 5% de la casa de subastas se considera en el cálculo de ganancias",
    "toggleAllFavorites": "Alternar todos los favoritos",
    "clickToCopy": "Clic para copiar: {{name}}",
    "priceAfterAHCut": "Precio tras comisión de CS: {{price}}",
    "noCompetition": "Sin competencia",
    "noCompetitionTooltip": "No hay anuncio conocido en el reino de venta.",
    "population": "Población: {{population}}",
    "viewOnWowhead": "Ver {{name}} en Wowhead",
    "addToFavorites": "Agregar a favoritos",
    "removeFromFavorites": "Eliminar de favoritos",
    "sessionExpiredFavorite": "Sesión expirada. Por favor, vuelve a iniciar sesión.",
    "failedToUpdateFavorite": "Error al actualizar el favorito",
    "addSnipeAlert": "Añadir alerta de snipe",
    "editSnipeAlert": "Editar alerta de snipe",
    "headers": {
      "itemName": "Nombre del objeto",
      "category": "Categoría",
      "ilvl": "ilvl",
      "sellRate": "Tasa de venta",
      "expansion": "Expansión",
      "quality": "Calidad",
      "extraStats": "Stats extra",
      "saleAvg": "Venta promedio",
      "regionMarketValue": "VM región",
      "saleAvgVsBuy": "Venta prom. vs Compra",
      "sellVsBuy": "Venta vs Compra",
      "sellPrice": "Precio de venta",
      "sellRealm": "Reino de venta",
      "buyPrice": "Precio de compra",
      "buyRealm": "Reino de compra"
    },
    "columnsTitle": "Columnas",
    "columnsReset": "Restablecer",
    "columnsDragToReorder": "Arrastra para reordenar",
    "columnsToggleVisibility": "Clic en el ojo para alternar visibilidad",
    "columnSettings": "Configuración de columnas",
    "dragReorder": "Arrastra para reordenar {{column}}",
    "hideColumn": "Ocultar {{column}}",
    "showColumn": "Mostrar {{column}}",
    "rowActions": "Acciones de fila",
    "actions": {
      "selectionSection": "Selección",
      "pinSection": "Fijar arriba",
      "selectPage": "Seleccionar página",
      "deselectPage": "Deseleccionar página",
      "selectAll": "Seleccionar todo",
      "deselectAll": "Deseleccionar todo",
      "sortFavorites": "Fijar favoritos",
      "sortSnipes": "Fijar alertas de snipe",
      "sortSelected": "Fijar seleccionados",
      "columnSettings": "Configuración de columnas..."
    },
    "sortHint": "Haz clic para ordenar",
    "sortHintMulti": "Haz clic para ordenar · Mayús+clic para orden secundario",
    "selectRow": "Seleccionar {{name}}",
    "emptyFiltered": "Ningún objeto coincide con tus filtros actuales",
    "emptyResetFilters": "Restablecer filtros",
    "emptyUpdating": "Hay una actualización de región en curso — los nuevos datos llegarán pronto."
  },
  "multipleSelect": {
    "noResults": "No se encontraron resultados",
    "selectAll": "Seleccionar todo",
    "clearAll": "Limpiar todo",
    "selectOption": "Seleccionar opción",
    "selectMultipleOptions": "Seleccionar varias opciones",
    "selected": "seleccionado(s)",
    "searchOptions": "Buscar opciones",
    "noItemsSelected": "Ningún elemento seleccionado",
    "search": "Buscar...",
    "items": "elementos"
  },
  "hierarchicalSelect": {
    "selectAll": "Seleccionar todo",
    "clearAll": "Limpiar todo",
    "expand": "Expandir",
    "collapse": "Contraer",
    "selected": "seleccionado(s)",
    "noItemsSelected": "Seleccionar categorías...",
    "items": "categorías",
    "triggerAriaLabel": "Seleccionar {{items}}. {{count}} seleccionados."
  },
  "hoverChart": {
    "high": "Alto:",
    "low": "Bajo:",
    "avg": "Prom.:"
  },
  "tokenDisplay": {
    "label": "Ficha de WoW",
    "signalBuy": "Señal de compra — el precio es favorable en este momento",
    "signalWait": "Espera — es probable que el precio siga bajando",
    "signalHold": "Mantén — no hay una tendencia clara por ahora",
    "loading": "Cargando...",
    "error": "Error",
    "priceHistory": "Historial de precios de 14 días",
    "high": "Alto: ",
    "low": "Bajo: ",
    "avg": "Prom.: ",
    "momentum": "Impulso",
    "slowing": "Desacelerando ({{steps}})",
    "atCap": "En el límite del 1%",
    "steps": "{{count}} paso",
    "stepsPlural": "{{count}} pasos"
  },
  "nextUpdate": {
    "nextDataUpdate": "Próxima actualización de datos",
    "dataSourceStatus": "Estado de las fuentes de datos",
    "tsmData": "Datos TSM:",
    "blizzardRealm": "Reino Blizzard:",
    "liveUpdates": "Actualizaciones en vivo:",
    "connected": "Conectado",
    "reconnecting": "Reconectando...",
    "retry": "Reintentar",
    "autoRefresh": "Actualización automática:",
    "autoRefreshEnabled": "La página se actualizará automáticamente cuando haya nuevos datos disponibles",
    "autoRefreshDisabled": "Haz clic en el ícono de actualización cuando los nuevos datos estén listos",
    "loadingStatus": "Cargando estado de datos...",
    "viewStatus": "Ver estado de fuentes de datos",
    "refreshData": "Actualizar datos",
    "reloading": "Recargando",
    "liveUpdatesConnected": "Actualizaciones en vivo conectadas",
    "liveUpdatesReconnecting": "Reconectando...",
    "tsmFresh": "Datos TSM actualizados (< 24h)",
    "tsmStale24": "Datos TSM próximos a caducar (24-25h)",
    "tsmStale25": "Datos TSM desactualizados (> 25h)",
    "toggleAutoRefresh": "Alternar actualización automática"
  },
  "regionUpdateProgress": {
    "updating": "Actualizando datos de región",
    "realmsProgress": "{{updated}}/{{total}} reinos ({{percent}}%)",
    "autoRefresh": "Los datos se actualizarán automáticamente cuando estén listos",
    "reloadPartial": "Datos parciales disponibles — cargar ahora"
  },
  "filterFlyout": {
    "filtersButton": "Filtros",
    "loadingPresets": "Cargando...",
    "selectPreset": "Seleccionar ajuste...",
    "presetsSection": "Ajustes",
    "save": "Guardar",
    "update": "Actualizar",
    "delete": "Eliminar",
    "export": "Exportar",
    "import": "Importar",
    "importPreset": "Importar ajuste…",
    "presetNamePlaceholder": "Nombre del ajuste...",
    "shareCode": "Compartir este código:",
    "copy": "Copiar",
    "done": "Hecho",
    "pasteCodePlaceholder": "Pegar código aquí...",
    "applyFilters": "Aplicar filtros",
    "resetFilters": "Restablecer filtros",
    "refreshNow": "Actualizar ahora",
    "reset": "Restablecer",
    "deletePresetTitle": "Eliminar preajuste",
    "deletePresetMessage": "¿Seguro que quieres eliminar este preajuste? Esta acción no se puede deshacer."
  },
  "discord": {
    "title": "Integración con Discord",
    "description": "Vincula tu cuenta de Discord para recibir notificaciones personalizadas y actualizaciones de nuestro bot.",
    "accountLinked": "Cuenta de Discord vinculada",
    "connectedAs": "Conectado como:",
    "unlink": "Desvincular",
    "dmVerifiedBadge": "DMs verificados: Tu Discord puede recibir notificaciones de nuestro bot.",
    "dmVerificationTitle": "Se requiere verificación de DMs",
    "dmVerificationDesc": "Para habilitar las notificaciones, necesitamos confirmar que nuestro bot puede enviarte mensajes directos. Asegúrate de tener los DMs habilitados para al menos un servidor que compartas con nuestro bot.",
    "sendVerificationCode": "Enviar código de verificación a mi Discord",
    "sendingCode": "Enviando código...",
    "codeSentInstructions": "Revisa tus DMs de Discord para un código de 6 dígitos de nuestro bot. Si no recibiste un DM, verifica en tu configuración en Contenido y Social > Permisos sociales que los mensajes directos estén activados.",
    "enterCodePlaceholder": "Introduce el código de 6 dígitos",
    "verify": "Verificar",
    "resendCode": "Reenviar código",
    "notificationSettings": "Configuración de notificaciones",
    "verifyDmsFirst": "(verifica los DMs primero)",
    "botFeaturesAvailable": "Funciones del bot disponibles: Ahora puedes recibir mensajes privados para actualizaciones de región, snipes de objetos y mascotas, snipes iLvl BoE y precio del token de WoW.",
    "notConnected": "No conectado: Vincula tu cuenta de Discord para habilitar las notificaciones y funciones del bot.",
    "connectingToDiscord": "Conectando a Discord...",
    "linkAccount": "Vincular cuenta de Discord",
    "regionUpdateLabel": "Notificaciones de actualización de región",
    "regionUpdateDesc": "Recibe notificaciones cuando los datos de subastas se actualicen para tus regiones seleccionadas.",
    "sendTestDm": "Enviar DM de prueba",
    "sendingTest": "Enviando…",
    "sendTestWebhook": "Probar",
    "testMessageHint": "Envía un mensaje de prueba para confirmar que la entrega a Discord funciona sin esperar a un snipe real.",
    "categoriesTitle": "Categorías de notificación",
    "categoriesDesc": "Envía las alertas de snipe a distintos canales de Discord. Cada categoría tiene su propia URL de webhook y su propio modo de mención.",
    "categoriesPremiumHint": "Las categorías adicionales requieren una suscripción premium.",
    "categoryNamePlaceholder": "Nombre de la categoría",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Mención:",
    "defaultLabel": "Predeterminada",
    "defaultCategoryTitle": "Categoría predeterminada",
    "noWebhookSet": "sin webhook configurado",
    "setAsDefault": "Establecer como predeterminada",
    "edit": "Editar",
    "delete": "Eliminar",
    "add": "Agregar",
    "addCategory": "+ Agregar categoría",
    "deleteCategoryTitle": "Eliminar categoría",
    "deleteCategoryMessage": "¿Seguro que quieres eliminar la categoría \"{{name}}\"? Las alertas asignadas usarán tu categoría predeterminada."
  },
  "csvExport": {
    "title": "Exportar CSV",
    "noItems": "No hay elementos disponibles.",
    "copy": "Copiar al portapapeles",
    "copied": "¡CSV copiado al portapapeles!",
    "copyFailed": "Error al copiar",
    "download": "Descargar CSV"
  },
  "updateBanner": {
    "title": "Actualización disponible",
    "description": "Una nueva versión está lista.",
    "reload": "Recargar",
    "dismiss": "Descartar"
  },
  "premiumPreviewBanner": {
    "title": "Tienes acceso Premium completo",
    "dayLeftOne": "Queda 1 día",
    "daysLeft": "Quedan {{count}} días",
    "dismiss": "Descartar"
  },
  "tour": {
    "start": "Iniciar tutorial de esta página"
  },
  "filterSidebar": {
    "profitRange": "Rango de ganancia",
    "crafted_include": "Todos los objetos",
    "crafted_excluded": "Excluir elaborados",
    "crafted_exclusive": "Solo elaborados",
    "showPositiveSaleAvgVsBuy": "Solo promedio de venta positivo vs compra",
    "presetClickToDeselect": "Clic para deseleccionar el ajuste preestablecido",
    "collapseSidebar": "Contraer filtros",
    "expandSidebar": "Expandir filtros"
  },
  "dashboard": {
    "loadError": "No se pudieron cargar los datos del panel. Verifica tu conexión e intenta de nuevo.",
    "greeting": {
      "morning": "Buenos días",
      "afternoon": "Buenas tardes",
      "evening": "Buenas noches"
    },
    "subtitle": "Esto es lo que ocurre en la casa de subastas hoy.",
    "kpi": {
      "opportunities": "Oportunidades"
    },
    "topOpportunities": {
      "title": "Mejores oportunidades",
      "viewAll": "Ver todo",
      "itemsFound": "objetos encontrados en",
      "realms": "reinos",
      "openTool": "Abrir herramienta de flipping",
      "ilvl": "ilvl",
      "sellRate": "tasa de venta",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "No se pudieron guardar los ajustes. Se restauró el último valor guardado.",
      "saved": "Guardado",
      "sellRateTooltip": "La tasa de venta usa una escala de 0 a 1: la proporción de subastas publicadas que realmente se venden cada día. 0.1 ≈ 10% de los anuncios."
    },
    "recentSnipes": {
      "title": "Snipes recientes",
      "monitoringRealms": "Monitorizando {{count}} reinos",
      "vsTarget": "vs objetivo",
      "itemsMonitored": "objetos siendo monitorizados",
      "configureAlerts": "Configurar alertas",
      "noSnipes": "No hay snipes este ciclo",
      "saved": "ahorrado"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "Ver estadísticas de reinos"
    },
    "quickAccess": {
      "title": "Acceso rápido"
    },
    "onboarding": {
      "title": "Primeros pasos",
      "progress": "{{done}}/{{total}} completados",
      "hide": "Ocultar lista",
      "steps": {
        "realms": "Configura tus reinos",
        "preset": "Crea un ajuste preestablecido de filtros inicial",
        "flipping": "Ejecuta tu primer escaneo de flipping",
        "discordLink": "Vincula tu cuenta de Discord",
        "snipe": "Configura las alertas de snipe",
        "discordJoin": "Únete al servidor de Discord"
      },
      "createPreset": "Crear ajuste preestablecido",
      "creatingPreset": "Creando…",
      "starterPresetName": "Inicial",
      "configureRealmsFirst": "Configura primero tus reinos para crear un ajuste preestablecido",
      "presetLimitReached": "Alcanzaste el límite de ajustes preestablecidos guardados",
      "createPresetFailed": "No se pudo crear el ajuste preestablecido. Intenta de nuevo."
    },
    "activity": {
      "title": "Actividad",
      "timeAgoLess1m": "<1m",
      "timeAgoMinutes": "hace {{count}}m",
      "timeAgoHours": "hace {{count}}h",
      "dataRefreshed": "Datos actualizados — {{n}} oportunidades encontradas",
      "realmDataUpdated": "Datos de reinos {{region}} actualizados",
      "waitingForData": "Esperando primera actualización de datos…",
      "snipeAlertsActive": "Las alertas de snipe están activas y monitorizando tus reinos",
      "tokenTracked": "El precio del WoW Token se actualiza cada 20 minutos"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Volver arriba",
  "slider": {
    "min": "Mín",
    "max": "Máx",
    "minAriaLabel": "Valor mínimo",
    "maxAriaLabel": "Valor máximo",
    "numericInput": "Entrada numérica de {{label}}"
  },
  "inputBox": {
    "clear": "Borrar entrada",
    "required": "obligatorio"
  },
  "auctionator": {
    "title": "Listas de compra de Auctionator",
    "account": "Cuenta:",
    "allAccounts": "Todas las cuentas",
    "noItems": "No hay objetos disponibles para la cuenta seleccionada."
  },
  "popup": {
    "getTitle": "Obtener {{title}}",
    "content": "Contenido",
    "noContent": "No hay contenido disponible",
    "copyTitle": "Copiar {{title}}",
    "copyContent": "Copiar contenido",
    "titleContent": "Contenido de {{title}}",
    "videoContent": "Contenido de video",
    "videoNotSupported": "Tu navegador no es compatible con la etiqueta de video."
  },
  "snipePopup": {
    "ariaLabel": "Alerta de snipe para {{name}}",
    "titleItem": "Alerta de snipe de objeto",
    "titlePet": "Alerta de snipe de mascota",
    "maxBuyoutPrice": "Precio máximo de compra directa",
    "pricePlaceholder": "p. ej. 500g o 500g 50s",
    "saving": "Guardando...",
    "updateAlert": "Actualizar alerta",
    "setAlert": "Crear alerta"
  },
  "refreshingData": "Actualizando datos...",
  "toolAccess": {
    "subscriptionRequired": "¡Necesitas una suscripción activa para usar esta herramienta!",
    "premiumRequired": "¡Necesitas una suscripción premium activa para usar esta herramienta!"
  }
}
